import { PAUSED_STATUS_VALUE } from 'conversations-internal-schema/sla/constants/enums';
import { getActiveSLAFromTicket } from './getActiveSLAFromTicket';
import { getSlaPausedStatus } from '../../operators/ticketGetters';
export const ticketHasActiveSLAs = ticket => Boolean(getActiveSLAFromTicket(ticket));
export const ticketIsPaused = ticket => getSlaPausedStatus(ticket) === PAUSED_STATUS_VALUE;